import {
  CreateDistributionExpeditionDto,
  CreateVehiclePlanningDto,
  DistributionExpedition,
  DistributionExpeditionReport,
  DistributionExpeditionsQueryDto,
  DistributionExpeditionStatistics,
  UpdateDistributionExpeditionDto,
  ValidateBarcodeResponse
} from '@/types/distribution-expeditions';

import { instance } from './config';

export const getDistributionExpeditions = async (query: DistributionExpeditionsQueryDto) => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, String(value));
    }
  });
  const data = await instance(`distribution-expeditions?${params.toString()}`);
  return data as { results: DistributionExpedition[]; total: number; page: number; limit: number };
};

export const getDistributionExpeditionById = async (id: string) => {
  const data = await instance(`distribution-expeditions/${id}`);
  return (data as { result: DistributionExpedition }).result;
};

export const createDistributionExpedition = async (dto: CreateDistributionExpeditionDto) => {
  const data = await instance('distribution-expeditions', {
    method: 'POST',
    body: JSON.stringify(dto)
  });
  return (data as { result: DistributionExpedition }).result;
};

export const updateDistributionExpedition = async (id: string, dto: UpdateDistributionExpeditionDto) => {
  const data = await instance(`distribution-expeditions/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(dto)
  });
  return (data as { result: DistributionExpedition }).result;
};

export const deleteDistributionExpedition = async (id: string) => {
  await instance(`distribution-expeditions/${id}`, {
    method: 'DELETE'
  });
};

export const getDistributionExpeditionStatistics = async (id: string) => {
  const data = await instance(`distribution-expeditions/${id}/statistics`);
  return data as DistributionExpeditionStatistics;
};

export const validateBarcode = async (id: string, barcode: string) => {
  const data = await instance(`distribution-expeditions/${id}/validate-barcode`, {
    method: 'POST',
    body: JSON.stringify({ barcode })
  });
  return data as ValidateBarcodeResponse;
};

export const createVehiclePlanning = async (id: string, dto: CreateVehiclePlanningDto) => {
  const data = await instance(`distribution-expeditions/${id}/vehicle-planning`, {
    method: 'POST',
    body: JSON.stringify(dto)
  });
  return data;
};

export const getDistributionExpeditionReport = async (id: string) => {
  const data = await instance(`distribution-expeditions/${id}/report`);
  return data as DistributionExpeditionReport;
};
